import React from 'react'
import DetailsSection from "./DetailsSection";

// Wrapper component of DetailsSection component.
const Wrapper = (props => {
    /* --------------------------------------------- */
    return (
        <>
            <DetailsSection {...props} />
        </>
    )
})
export default Wrapper